import { useEffect, useState } from "react";
import { WarningCircle, ArrowsClockwise, CheckCircle } from "@phosphor-icons/react";
import api, { onServerStatus } from "../lib/api";

export default function ServerStatusBanner() {
  const [down, setDown] = useState(false);
  const [checking, setChecking] = useState(false);
  const [justRecovered, setJustRecovered] = useState(false);

  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => onServerStatus(setDown), []);
  useEffect(() => {
    const on = () => setOffline(false); const off = () => setOffline(true);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  useEffect(() => {
    if (!down) return;
    const check = async () => {
      setChecking(true);
      try {
        await api.get("/health");
        setDown(false);
        setJustRecovered(true);
        setTimeout(() => setJustRecovered(false), 4000);
      } catch {
        /* ancora giù */
      } finally {
        setChecking(false);
      }
    };
    const t = setInterval(check, 15000);
    return () => clearInterval(t);
  }, [down]);

  const retry = async () => {
    setChecking(true);
    try {
      await api.get("/health");
      setDown(false);
      setJustRecovered(true);
      setTimeout(() => setJustRecovered(false), 4000);
    } catch {
      /* ancora giù */
    } finally {
      setChecking(false);
    }
  };

  if (justRecovered) {
    return (
      <div
      className="sticky top-0 left-0 right-0 z-[100] bg-emerald-600 text-white px-4 py-2.5 flex items-center justify-center gap-2 shadow-lg"
        data-testid="server-status-recovered"
      >
        <CheckCircle size={18} weight="fill" />
        <span className="text-sm font-medium">Collegamento ripristinato. Puoi continuare a lavorare.</span>
      </div>
    );
  }

  if (offline) {
    return (
      <div className="sticky top-0 left-0 right-0 z-[100] bg-slate-700 text-white px-4 py-2 flex items-center justify-center gap-2 shadow-lg" data-testid="server-status-offline">
        <WarningCircle size={16} weight="fill" /><span className="text-sm">Sei offline: controlla la connessione del dispositivo. I dati sono al sicuro sul server.</span>
      </div>
    );
  }
  if (!down) return null;

  return (
    <div
      className="sticky top-0 left-0 right-0 z-[100] bg-amber-500 text-amber-950 shadow-lg"
      data-testid="server-status-banner"
    >
      <div className="max-w-[1400px] mx-auto px-4 py-2.5 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
        <WarningCircle size={20} weight="fill" className="shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold leading-tight">Il server non risponde in questo momento</div>
          <div className="text-xs opacity-80 leading-tight mt-0.5">
            I tuoi dati sono al sicuro. Aspetta qualche istante e riprova: ricontrollo automaticamente ogni 15 secondi.
          </div>
        </div>
        <button
          type="button"
          onClick={retry}
          disabled={checking}
          data-testid="server-status-retry"
          className="shrink-0 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-950 text-amber-50 text-xs font-semibold hover:bg-amber-900 disabled:opacity-60 transition-colors"
        >
          <ArrowsClockwise size={14} weight="bold" className={checking ? "animate-spin" : ""} />
          {checking ? "Verifico..." : "Riprova ora"}
        </button>
      </div>
    </div>
  );
}
